import { colors } from '~/tailwind.config'

export type TailwindColors = keyof typeof colors

/**
 * Get a theme color.
 */
export function twColor(name: TailwindColors, opacity = 100) {
    return String(colors[name]) + Math.round((opacity / 100) * 255).toString(16)
}

/**
 * Check if a theme color is dark.
 */
export function isTailwindColorDark(name: TailwindColors) {
    return isColorDark(twColor(name))
}

/**
 * Check if a color is dark.
 */
export function isColorDark(color?: string) {
    if (!color) return false

    const c = color.slice(1)
    const rgb = parseInt(c, 16)
    const r = (rgb >> 16) & 0xff
    const g = (rgb >> 8) & 0xff
    const b = (rgb >> 0) & 0xff
    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

    return luma < 150
}

/**
 * Get color style.
 */
export function coloringStyle(backgroundColor?: string) {
    if (!backgroundColor) return

    const color = isColorDark(backgroundColor) ? 'white' : 'black'

    return {
        backgroundColor,
        color
    }
}
